import { DollarSign } from 'lucide-react';
import { FormAccordionCard, FormSectionHeader } from '@/components/molecules';
import {
  FinancialsSection,
  type FinancialsSectionProps,
} from '@/components/organisms/FinancialsSection';

interface EstimateFinancialsSectionProps extends FinancialsSectionProps {
  open: boolean;
  onToggle: () => void;
  bare?: boolean;
}

export function EstimateFinancialsSection({
  open,
  onToggle,
  bare = false,
  discountValue,
  depositValue,
  ...financialsProps
}: EstimateFinancialsSectionProps) {
  const statusBadge = discountValue > 0 || depositValue > 0 ? 'Set' : undefined;
  if (bare) {
    return (
      <FinancialsSection
        discountValue={discountValue}
        depositValue={depositValue}
        {...financialsProps}
      />
    );
  }

  return (
    <FormAccordionCard
      open={open}
      header={
        <FormSectionHeader
          icon={DollarSign}
          title="Financials"
          open={open}
          onToggle={onToggle}
          statusBadge={statusBadge}
        />
      }
    >
      <FinancialsSection
        discountValue={discountValue}
        depositValue={depositValue}
        {...financialsProps}
      />
    </FormAccordionCard>
  );
}
